import { ToastContextValue } from '../components/ToastProvider';

export function handleApiError(e: unknown, fallbackMessage: string, toast: Pick<ToastContextValue, 'error'>): string {
  let rawMsg: string;
  if (e instanceof Error) rawMsg = e.message;
  else if (typeof e === 'string') rawMsg = e;
  else rawMsg = JSON.stringify(e);

  // Teile extrahieren: Status & Body
  let status: string | null = null;
  let bodySnippet: string | null = null;
  // Beispiel: "GET /api/x failed: 404 Not Found. Body: {"error":"Not Found"}"
  const statusMatch = /(failed:\s*)(\d{3})(?:\s+([A-Za-z ]+))?/.exec(rawMsg);
  if (statusMatch) status = statusMatch[2];
  const bodyMatch = /Body:\s([^]*?$)/.exec(rawMsg);
  if (bodyMatch) bodySnippet = bodyMatch[1].trim();
  if (bodySnippet && bodySnippet.length > 400) bodySnippet = bodySnippet.slice(0, 397) + '…';

  let composed = fallbackMessage;
  if (status) composed += ` (Status ${status})`;
  if (bodySnippet) composed += `\n${bodySnippet}`;
  // Wenn keine Zusatzinfos, aber ursprüngliche Message von Bedeutung:
  if (!status && !bodySnippet && rawMsg) composed += `\n${rawMsg}`;

  toast.error(composed);
  return composed;
}
